/**
 * Vue: Back in stock
 * ------------------------------------------------------------------------------
 * - Uses inline template.
 *
 */

function BackInStock () {
    const selectors = {
        form: ".back-in-stock__form",
        input: '.back-in-stock__input',
        submit: ".back-in-stock__submit"
    }
    const elements = {
        form_elements: document.querySelectorAll(selectors.form),
        input_elements: document.querySelectorAll(selectors.input),
        submit_elements: document.querySelectorAll(selectors.submit)
    }

    const values = {
        emailValue: elements.input_elements[0].value,
        variantId: elements.form_elements[0].getAttribute("data-variant-id"),
        variantAvailable: elements.form_elements[0].getAttribute("data-variant-available"),
        productId: elements.form_elements[0].getAttribute("data-product-id")
    }

    const modifiers = {
        success: "success",
        error: "error",
    }

    const initEventListeners = () =>{
        elements.form_elements.forEach(backInStockForm => {
            // console.log('backInStockForm', backInStockForm);
            backInStockForm.addEventListener("submit", (event)=>{
                // console.log('form submitted', event)
                event.preventDefault();
                handleBackInStockSubmit(event);
            })
        });

        elements.input_elements.forEach(backInStockInputs => {
            backInStockInputs.addEventListener('focusin', (e)=>{
                e.target.closest('.back-in-stock__inputs').classList.add('active')
            })

            backInStockInputs.addEventListener('focusout', (e)=>{
                e.target.closest('.back-in-stock__inputs').classList.remove('active')
            })

            backInStockInputs.addEventListener('input', ({target})=>{
                const value = target.value;
                const isDisabled = target.closest('form').querySelector(selectors.submit).hasAttribute('disabled')
                if(value.length && isDisabled) {
                    target.closest('form').querySelector(selectors.submit).removeAttribute('disabled')
                } else if (!value.length && !isDisabled) {
                    target.closest('form').querySelector(selectors.submit).setAttribute('disabled', true)
                }
            })
        });
    }

    const getBackInStockDisabled = (event) => {
        let emailValue = elements.input_elements[0].value;
        elements.input_elements.forEach(backInStockInputs => {
            emailValue = backInStockInputs.value;
        });
        return ( values.variantId.length && values.variantAvailable === 'false' && emailValue.length)
    }

    const handleBackInStockSubmit = (event) => {
        // console.log('Event', event.target.querySelector(selectors.input).value);
        const emailValue = event.target.querySelector(selectors.input).value;
        if (!emailValue) {
            return
        }
        
        const data = {
            // eslint-disable-next-line id-length
            a: window.theme.api.klaviyo,
            email: emailValue,
            // Subscribe to newsletter list ID, optional.
            // g: 'list_id',
            platform: 'shopify',
            product: values.productId,
            // eslint-disable-next-line babel/camelcase
            subscribe_for_newletter: false,
            variant: values.variantId
        }
        const formData = new FormData()

        Object.keys(data).forEach((key) => {
            formData.append(`${key}`, `${data[key]}`)
        })
        fetch(
            'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
            {
                body: formData,
                credentials: 'omit',
                method: 'POST',
                mode: 'no-cors',
                referrer: document.URL,
                referrerPolicy: 'no-referrer-when-downgrade'
            }
        )
            .then(() => {
                onSuccess()
            })
            .catch((error) => {
                onError()
                throw new Error('Failed to submit back in stock', error)
            })
    }

    const onSuccess = () => {
        elements.form_elements.forEach(backInStockForm => {
            backInStockForm.classList.remove(modifiers.error)
            backInStockForm.classList.add(modifiers.success)
        });
    }

    const onError = () => {
        elements.form_elements.forEach(backInStockForm => {
            backInStockForm.classList.add(modifiers.error)
            backInStockForm.classList.remove(modifiers.success)
        });
    }

    const onInit = () => {
        initEventListeners();
        if(getBackInStockDisabled()) {
            handleBackInStockSubmit();
        }
    }
    onInit();
}

document.addEventListener("DOMContentLoaded", () => {
    const wrapper = document.querySelector('.product-form__back-in-stock');
        if (wrapper) {
            BackInStock();
        }
    }
);


